import axios from 'axios'
import NProgress from 'nprogress'

const apiClient = axios.create({
  baseURL: 'https://kehillah-fleet-api.herokuapp.com/api',
  // baseURL: 'https://api.kehillahghana.com/api',
  timeout: 60000
})

apiClient.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

apiClient.interceptors.response.use(response => {
  NProgress.done();
  return response;
})


export default apiClient
